import { paths } from '@/generated/supplier-experience-api';
import apiClient from '@/lib/apiClient';
import { parseContentDispositionFilename, triggerBlobDownload } from '@/utils/downloadCsvFromPost';

export type SupplierMarketClearCsvRequestBody = NonNullable<
  paths['/supplier-market-clears/{clearId}/csv']['post']['requestBody']
>['content']['application/json'];

export interface DownloadSupplierMarketClearCsvArgs {
  clearId: number;
  makerOrganizationUuid: string;
}

/**
 * Download a single supplier market clear (TMC pending clear) CSV via SEA.
 * The filename comes from the backend's `Content-Disposition` header.
 */
export const downloadSupplierMarketClearCsv = async ({
  clearId,
  makerOrganizationUuid,
}: DownloadSupplierMarketClearCsvArgs): Promise<void> => {
  const body: SupplierMarketClearCsvRequestBody = { makerOrganizationUuid };

  const response = await apiClient.post(`api/supplier-experience/supplier-market-clears/${clearId}/csv`, {
    json: body,
  });
  const filename =
    parseContentDispositionFilename(response.headers.get('content-disposition')) ?? `${clearId}_market-clear.csv`;
  triggerBlobDownload(await response.blob(), filename);
};
